/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type SentimentFieldFieldValue = (typeof SentimentFieldFieldValue)[keyof typeof SentimentFieldFieldValue];

export const SentimentFieldFieldValue = {
  very_positive: 'very_positive',
  positive: 'positive',
  neutral: 'neutral',
  negative: 'negative',
  very_negative: 'very_negative',
} as const;
